var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { attrs: { type: "card" } },
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("el-button", { attrs: { size: "mini", type: "primary" } }, [
            _vm._v(" props.id = " + _vm._s(_vm.id) + " ")
          ])
        ],
        1
      ),
      _c("p", { staticClass: "d2-mt-0" }, [
        _vm._v(
          "在下面的输入框输入任意字符后，切换到其它页面，再回到此页时输入框文字保留，证明被缓存"
        )
      ]),
      _c("p", [_vm._v("注意：此页面根据不同 params 打开后数据不会混淆")]),
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("p", [_vm._v("el-input")]),
              _c("el-input", {
                attrs: { placeholder: "input here" },
                model: {
                  value: _vm.data.value,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "value", $$v)
                  },
                  expression: "data.value"
                }
              })
            ],
            1
          ),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [_vm._v("html input")]),
            _c("div", { staticClass: "el-input el-input--default" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.value,
                    expression: "data.value"
                  }
                ],
                staticClass: "el-input__inner",
                attrs: { placeholder: "input here" },
                domProps: { value: _vm.data.value },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.data, "value", $event.target.value)
                  }
                }
              })
            ])
          ])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }